export default {
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [EN]",
    homepageTitleGC: "SMART-TEAM-DEV-PORTAL",
    homepageTitleGES: "PORTAL",
    homepageIcon: {icopathGC: "gc/gcLogo", colorGC: "black|white", icopathGES: "gc/gesLogo", colorGES: "black|white"},
    programVersion: "Program version: ",
    loremipsumdolor: "Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
    moredetailed: "More detailed",
    loadingdata: "Loading data",
    savingdata: "Saving data",
    processing: "Processing...",
    lookingUpDnsName: "Looking for a DNS server name",
    finish: "Done",
    error: "Error",
    warning: "Warning",
    send: "Send",
    sendMeCode: "Send me code",
    changetheme: "Change color theme",
    userpage: "User parameters",
    online: "Online",
    offline: "Offline",
    usrexit: "Exit",
    usrlogin: "Enter",
    fieldlogin: "User login / phone",
    fieldpass: "Password",
    authFormTitle: "User authorization form",
    buttonlogin: "Sign in",
    buttonclose: "Close",
    collapseExpand: "Expand",
    buttonExpandWindow: "Expand Window",
    buttonCollapseWindow: "Collapse Window",
    redirection: "Redirection...",
    undo: "Undo",
    redo: "Redo",
    back: "Back",
    forward: "Forward",
    copy: "Copy",
    paste: "Paste",
    cut: "Cut",
    help: "Help",
    homebuttontitle: "Home page",
    mainmenutitle: "Main menu",
    preview: "Preview",
    selectItems: "Select items",
    standartQuestion: "Standard question",
    removeItems: "Remove theese items from DB",
    adminTools: "Admin Tools",
    replaceThumbnailPhotoInAD: "Replace Thumbnail Image in ActiveDirectory",
    showRecordset: "View recordset",
    editRecordset: "Edit recordset",
    createRecordset: "Create recordset",
    createCopyOfRecordset: "Create a copy of a recordset",
    removeRecordset: "Remove recordset",
    removeRecordsetFromDatabase: "Delete a record from the database permanently",
    restoreRemovedRecordset: "Restore the removed recordset",
    setAsArchival: "Mark recordset as an archival",
    unsetAsArchival: "Restore selected recordset from the archive",
    disableUser: "Disable User",
    enableUser: "Enable User",
    disableGroup: "Disable Group",
    enableGroup: "Enable Group",
    unlockUser: "Unblock User",
    unbanUser: "Unban a User",
    replaceStatusToOnline: "Set status to online",
    replaceStatusToOffline: "Set status to offline",
    showUserActionsHistory: "View user activity history",
    userAttributesWillBeChanged: "The following attributes will be changed for the user ",
    selectGroupMembers: "Select Group's Members",
    removeSelectedUserFromGroup: "Remove selected User from Group",
    showInstalledPrograms: "Show installed programs",
    showInstalledPrinters: "Show installed printers",
    showProcesses: "Show running processes",
    getWindowsOfficeActivationStatus: "Get Windows and Office activation status",
    activateWindowsOffice: "Activate Windows and Office",
    ipConfigFlushDns: "Clear the DNS cache",
    turnOffTheComputer: "Turn off the computer",
    getScreenshotFromRemoteComputer: "Desktop screenshot",
    openInBrowser: "Open in browser",
    sendBallunMessageToComp: "Send a pop-up message to the user's computer",
    sendMessageToUserEmail: "Send message by Email",
    sendMessageToUserViber: "Send a message on Viber",
    sendMessageToUserTelegram: "Send a message to Telegram",
    sendMessageToUserMattermost: "Send a message to Mattermost",
    srvbgAppWillRestart: "Changing the start period of the 'ActiveDirectorySync' (syncADInterval) or 'compareUsersPhoto' (syncPhotoInterval) or 'clearOldUploads' services will cause the 'srvbg-app' program to restart after saving the settings!",
    srvbgSyslogWillRestart: "Enabling or disabling the 'SysLogServer' service will restart the 'srvbg-syslog' program",
    portalAppWillRestart: "Changing the start period of the 'clearOldUploads' service will cause the 'smartteamdev' program to restart after saving the settings!",
    srvbgHikWillRestart: "Changing the synchronization period with 'SKUD-SERVER' will restart the 'srvbg-skud' program",
    active: "Active",
    notActive: "Not active",
    enabled: "Enabled",
    disabled: "Disabled",
    locked: "Locked",
    lockedEditDel: "Locked from deletion and modification",
    unlocked: "Unlocked",
    adGroup: "Domain group",
    fbaGroup: "Custom group",
    adUser: "Domain user",
    fbaUser: "External user",
    guest: "Guest",
    banned: "Banned",
    usermenu: [
      { key: "changelng", label: "Change Language" },
      { key: "changetheme", label: "Change Theme" },
      { key: "changecompact", label: "Compact Intarface" },
      { key: "about", label: "About" },
      { key: "exit", label: "Exit from Application" }
    ]
  },
  e: {
    pageNotfoundOrDenied: "Page not found or you don't have the sufficient rights",
    accessDenied: "Access denied",
    userDontHaveAnougthRight: "You do not have sufficient rights",
    dbDenied: "Database access denied", // not used
    nullLoginOrPass: "Required arguments are missing - login & pass",
    userLoggedFailed: "Authorisation Error",
    incorrectOldPassword: "Incorrect old password",
    unknowErrorWhileReactElementsBuilding: "Unknown error when building React components",
    exportError: "Export error",
    cantFindTableRowWithKey: "Can't find the table row with key = ",
    unknownError: "Unknown error",
    somethingWrong: "Something went wrong",
    recIsNotFoundInDB: "Recordset is not found in the database",
    yandexMapsIsNotLoaded: "The Yandex-Maps module was not loaded. Perhaps he is switched off by Administrator",
    fileNotFound: "File not found",
    cryptoError1: "It was not possible to decipher the data from the server. Wrong Key or Initialization Vector!"
  },
  w: {
    enterOnlyLoginBeforeSendCode: "Please enter only your login or phone before receiving the code",
    allowedFileTypes: "You can only upload next files types: ",
    maxFileSizeError: "The file size must be no more than ",
    selectOnlyOneRow: "Select only one row",
    NotApplicableToThisTable: "Not applicable to this table",
    nothingSelected: "Nothing selected",
    needToSelectMoreThanOne: "More than 1 item must be selected",
    incorrectDataFormat: "Invalid data format",
    nameFieldRequiredBeforeGenerateLogin: "Field 'Name' must be filled before auto-generating a login!",
    loginFieldAlreadyFilled: "The 'login' field is already filled in. Erase values ​​before auto-generating a new one",
    mailFieldAlreadyFilled: "The 'mail' field is already filled in. Erase values ​​before auto-generating a new one",
    passFieldAlreadyFilled: "The 'password' field is already filled in. Erase values ​​before auto-generating a new one",
    thisNameAlreadyExistInAD: "This username already exists! Enter a new value",
    thisLoginAlreadyExistInAD: "This user login already exists! Enter a new value",
    userLoginAlreadyExist: "User with this Login / sAMAccountName already exists",
    groupAlreadyExist: "Such a group already exists",
    userNameAlreadyExist: "User with this Name already exists",
    cantRemoveTheLastRow: "Can't delete the last row",
    errFields1: "Not all fields are filled properly",
    serverReturnedEmptyArray: "The server returned an empty array",
    passIsNull: "The 'password' field is empty",
    newPassIsNull: "The 'new password' field is empty",
    newPass2IsNull: "The 'repeat password' field is empty",
    passTooShort: "The 'password' field is too short",
    newPassTooShort: "The 'new password' field is too short (must be at least 6 characters)",
    passMastHave: "The password must contain letters (uppercase and lowercase), numbers and at least one character (- # $ ! @ &)",
    passwordsMismatch: "Password mismatch",
    cantModifyADgroupUsers: "You cannot change the ActiveDirectory group membership in this application. Use the 'Domain Groups' or 'Domain Users' application",
    cantModifyLockedUser: "I cannot edit/delete Protected Users. You can only disable/enable these users or change their password",
    cantModifyADgroup: "You cannot change or delete ActiveDirectory groups in this application",
    cantRemoveADuser: "You cannot delete ActiveDirectory users in this application. Use the ActiveDirectory snap-in on the Domain Controller",
    cantModifyLockedRecordset: "Can't edit / delete protected recordset",
    recordsetDoesntExistInDB: "This Record does not exist in the database",
    sameFileAlreadyExistInUploads: "A file with the same name already exists in Uploads",
    contragentAlreadyExist: "A counterparty with the same name and TIN already exists in the database",
    employeeAlreadyExist: "An employee with such data already exists in the database",
    recordsetAlreadyExist: "Such recordset already exists in the database",
    recordsetSimmilarAlreadyExist: "You have changed the recordset so that the fields values coincided with another existing entry in the database!",
    recordsetAlreadyInRecycleBin: "The recordset is already in the Recycle Bin",
    noSelectedrecordsetsInRecycleBin: "No deleted recordsets selected",
    recordsetAlreadyIsArchival: "Recordset is already as archival",
    recordseIsNotArchival: "Recordset is not in the archive",
    copyingIsProhibited: "Copying data is prohibited",
    notYetDeveloped: "Not yet developed..."
  },
  i: {
    codeHasBeenSent: "The code has been sent",
    userLoggedSuccess: "You have successfully authorized",
    successDeleted: "Deleted successfully",
    successUpdated: "Updated successfully",
    successCreated: "Created successfully", // not used
    successOperation: "Completed successfully", // not used
    nothingHasChanged: "Nothing has changed",
    messageHasBeenSent: "Message sent",
    messageWillBeSentAfterSaveForm: "Message to the users will be sent after click on the 'Save' button",
    finish: "Done"
  },
  q: {
    doYouWantRemoveTheseItems: "Do You want to remove these Items?",
    doYouWantReplaceThumbnailPhoto: "Do you want to replace thumbnail images in ActiveDirectory for 00 selected Users?",
    doYouWantSwitchStatusToOnline: "Do you want to switch status to online?",
    doYouWantSwitchStatusToOffline: "Do you want to switch status to offline?",
    doYouWantToCreateUser: "Do you want to create a new AD-User ",
    doYouWantDisableSelectedUser: "Do you want to disable selected User in ActiveDirectory?",
    doYouWantEnableSelectedUser: "Do you want to enable selected User in ActiveDirectory?",
    doYouWantDisableSelectedGroup: "Do you want to disable the group ",
    doYouWantEnableSelectedGroup: "Do you want to enable the group ",
    doYouWantUnlockSelectedUser: "Do you want to unblock a selected user (after they have entered the wrong password many times)?",
    doYouWantToRemoveSelecctedUsersFromSelectedGroup: "Do you want to remove selected Users from Group",
    doYouWantAddUsersToGroup: "Do you want to add Users to Group",
    doYouWantRemoveUsersFromGroup: "Do you want to remove Users from Group",
    doYouWantRemoveGroup: "Do you want to delete the User Group ",
    doYouWantRemoveUser: "Do you want to delete a User ",
    doYouWantRemoveThisRecordset: "Do you want to delete this recordset?",
    doYouWantRemoveTheseRecordsets: "Do you want to delete these recordsets?",
    doYouWantRemoveTheseRecordsetsFromDB: "Do you want to delete these recordsets from the database?",
    doYouWantRestoreTheseRecordsets: "Do you want to restore these records?",
    doYouWantMarkTheeseRecordsAsArchival: "Do you want to mark these recordsets as archival?",
    doYouWantRestoreTheeseRecordsFromArchival: "Do you want to restore these recordsets from the archive?",
    gptForgetContext: "Start a new conversation (forget the context of the current conversation)?",
    resetAppSettings: "Do you want to reset application settings 'appname' to default from file 'apps/appname/index.js'?"
  },
  unit: {
    pcs: "pcs",
    m: "m",
    m2: "m²",
    m3: "m³",
    mm: "mm",
    kg: "kg"
  },
  ag: {
    sideBarColumnsTitle: "Columns",
    sideBarFiltersTitle: "Filters",
    autoWidthColumns: "Auto column width",
    quickChart: "Quick chart",
    online: "Online",
    onlinev: "Online (User was verified)",
    offline: "Offline",
    deprecated: "Deprecated or Broken",
    setQuickFilter: "Set a quick filter by this value",
    resetFilters: "Reset all filters",
    excelExport: "Export to Excel",
    jsonExport: "Export to JSON",
    dhcpDinamic: "DHCP dynamic",
    dhcpStatic: "DHCP static",
    ovpn: "OVPN",
    ipsec: "IPSEC",
    vpn: "VPN",
    l2tp: "L2TP",
    pptp: "PPTP",
    device: "Device",
    comp: "Computer / Notebook",
    phone: "Phone",
    tablet: "Tablet",
    printer: "Printer",
    mfu: "MFP",
    router: "Router / Switch",
    registrator: "Registrar",
    camera: "Camera",
    server: "Server",
    unknown: "Unknown",
    group: "Group",
    ungroup: "Ungroup",
    synology: "Synology DiskStation",
    windowsserver: "Windows server / computer",
    webserver: "Web server",
    otherserver: "Other server",
    connection: "Connection",
    fsowin: "FSO-Windows",
    fsoweb: "FSO-WEB",
    portal: "Portal",
    webservice: "WEB-service",
    otheraction: "Other action",
    disabledUser: "Disabled User",
    enabledUser: "Enabled User",
    deleteRow: "Delete row",
    addRow: "Add row"
  },
  gpt: {
    userDoesntHaveEnoughRightsToWorkWithGPT: "You do not have sufficient rights to analyze this table using ChatGPT",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "You do not have sufficient rights to run voice commands",
    thereAreNoDataForAnalysis: "No data for analysis",
    incorrectRequest: "Incorrect request",
    incorrectDatePeriod: "Incorrect dates period for building a request",
    speechRecognitionError: "Speech recognition error",
    speechRecognitionNull: "There is no recorded message. There is nothing to recognize",
    undefinedEmployee: "It was not possible to determine which employees are in question",
    undefinedCommand: "The command is not included in the list of permitted actions. Check out the list of permissible commands before calling a voice assistant",
    noAnswerFromChatGPT: "There is no answer from ChatGPT",
    ansWasCopiedToBuffer: "AI answer is copied to the clipboard",
    copyToBufferError: "There was an error when copying to the clipboard",
    voiceRecordingStart: "There is a record of the voice from the microphone",
    voiceRecordingStop: "The record of the voice is stopped",
    micPermissionsError: "There are no rights to access to the microphone of your device",
    tooltip1: "Data Analysis Using ChatGPT",
    tooltip2: "Run a voice command",
    selectCompany: "Please select a company"
  },
  adusers: {
    title: "Domain Users",
    headers: [
      { key: "name", title: "User name" },
      { key: "status", title: "Status" },
      { key: "thumbnailPhoto", title: "Photo" },
      { key: "sAMAccountName", title: "Login", hidden: true },
      { key: "company", title: "Company" },
      { key: "groups", title: "Groups", hidden: true, visfor: ["admins", "headship"] },
      { key: "phones", title: "Phones" },
      { key: "mail", title: "Email" },
      { key: "title", title: "Job title" },
      { key: "manager", hidden: true, title: "Manager" },
      { key: "description", title: "Description" },
      { key: "department", title: "Subdivision" },
      { key: "office", hidden: true, title: "Office" },
      { key: "lng", title: "Language", hidden: true, visfor: ["admins", "headship"] },
      { key: "country", title: "Country", hidden: true, visfor: ["admins", "headship"] },
      { key: "region", title: "Region", hidden: true, visfor: ["admins", "headship"] },
      { key: "city", title: "City", hidden: true, visfor: ["admins", "headship"] },
      { key: "street", title: "Address", hidden: true, visfor: ["admins", "headship"] },
      { key: "distinguishedName", title: "Distinguished Name", hidden: true, visfor: ["admins"] },
      { key: "adNotes", title: "Notes", hidden: true, visfor: ["admins", "headship"] },
      { key: "accountDisable", title: "Account is disabled", hidden: true },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins", "headship"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] }
    ]
  },
  adusers_devices: {
    headers: [
      { key: "summarystatus", title: "Device status" },
      { key: "devicetype", title: "Device type", hidden: true },
      { key: "connectiontype", title: "Connection type", hidden: true },
      { key: "status", title: "Status", hidden: true },
      { key: "devicename", title: "Device name" },
      { key: "internalip", title: "Internal IP" },
      { key: "externalip", title: "External IP", hidden: true },
      { key: "place", title: "Location" },
      { key: "caption", title: "Description" },
      { key: "lastOnlineTime", title: "When was online" },
      { key: "login", title: "User login", hidden: true }
    ]
  },
  adgroups: {
    title: "Domain Groups",
    headers: [
      { key: "sAMAccountName", title: "Group name"},
      { key: "memberOf", title: "memberOf" },
      { key: "description", title: "Description" }
    ]
  },
  addevices: {
    title: "Domain Computers",
    headers: [
      { key: "status", title: "Status" },
      { key: "name", title: "Device name" },
      { key: "description", title: "Description" },
      { key: "operatingSystem", title: "Operating System" },
      { key: "sAMAccountName", title: "User login", hidden: true },
      { key: "userName", title: "User name" },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] },
      { key: "distinguishedName", title: "distinguishedName", hidden: true, visfor: ["admins"] }
    ]
  },
  mikrotik: {
    title: "Routers Devices",
    headers: [
      { key: "summarystatus", title: "Device status" },
      { key: "devicetype", title: "Device type", hidden: true },
      { key: "connectiontype", title: "Connection type", hidden: true },
      { key: "status", title: "Status", hidden: true },
      { key: "devicename", title: "Device name" },
      { key: "login", title: "User Login" },
      { key: "userName", title: "User name" },
      { key: "internalip", title: "Internal IP" },
      { key: "externalip", title: "External IP", hidden: true },
      { key: "place", title: "Location" },
      { key: "caption", title: "Description", hidden: true },
      { key: "mac", title: "MAC-address", hidden: true, visfor: ["admins"] }
    ]
  },
  acsreporter: {
    title: "ACS Reporter",
    history: {
      forgetThisConversation: "Forget this conversation",
      headers: [
        {key: "strDate", title: "Date"},
        {key: "message", title: "Conversation start"}
      ]
    }
  },
  syslogserver: {
    title: "SyslogServer Events",
    headers: [
      { key: "login", title: "User Login" },
      { key: "action", title: "Event" },
      { key: "strDate", title: "Date time" },
      { key: "syslogClientType", title: "Server type" },
      { key: "actionType", title: "Action type" },
      { key: "serverName", title: "Server name", hidden: true },
      { key: "name", title: "User name" },
      { key: "devicetype", title: "Device type", hidden: true },
      { key: "devicename", title: "Device name" },
      { key: "connectiontype", title: "Connection type", hidden: true, visfor: ["admins", "headship"] },
      { key: "internalip", title: "Internal IP", hidden: true },
      { key: "externalip", title: "External IP", hidden: true, visfor: ["admins", "headship"] },
      { key: "place", title: "Location" }
    ],
    history: {
      forgetThisConversation: "Forget this conversation",
      headers: [
        {key: "strDate", title: "Date"},
        {key: "message", title: "Conversation start"}
      ]
    }
  },
  selectUsersGrid: {
    title: "Select Users",
    headers: [
      { key: "name", title: "User name" },
      { key: "sAMAccountName", title: "User login" },
      { key: "title", title: "Job title" },
      { key: "department", title: "Subdivision" }
    ]
  },
  usersettings: {
    title: "Current User settings"
  },
  programsettings: {
    knownIPAddresses: {
      headers: [
        {key: "ip", title: "External IP"},
        {key: "internalip", title: "Internal IP"},
        {key: "address", title: "Location"}
      ]
    },
    allowedExternalAccess: {
      headers: [
        {key: "ip", title: "External/Internal IP"},
        {key: "comment", title: "Comment"}
      ]
    },
    knownVPNaddresses: {
      headers: [{key: "VPNinternalip", title: "Internal IP addresses of VPN connections"}]
    },
    ADuserTemplates: {
      headers: [
        {key: "key", title: "key"},
        {key: "title_en", title: "English template name"},
        {key: "title_ru", title: "Russian template name"},
        {key: "title_tr", title: "Turkish template name"},
        {key: "groups", title: "Groups"},
        {key: "jobTitle", title: "Job title"},
        {key: "department", title: "Subdivision"},
        {key: "description", title: "Description"},
        {key: "company", title: "Company"},
        {key: "office", title: "Office"},
        {key: "manager", title: "Manager"}
      ]
    },
    mikrotikDevices: {
      headers: [
        {key: "active", title: "Is Active"},
        {key: "host", title: "Hostname"},
        {key: "version", title: "Mikrotik OS version"},
        {key: "username", title: "User"},
        {key: "password", title: "Password"}
      ]
    },
    sysLogServer_knownFileServers: {
      headers: [
        {key: "internalip", title: "Local IP address"},
        {key: "serverName", title: "Server name"},
        {key: "serverPath", title: "Initial path to the folder"}
      ]
    },
    sysLogServer_knownExternalUsers: {
      headers: [
        {key: "login", title: "Login in VPN connection"},
        {key: "name", title: "Display name"}
      ]
    },
    sysLogServer_ignoreFiles: {
      headers: [
        {key: "filemask", title: "File name mask"}
      ]
    },
    sysLogServer_ignoreActions: {
      headers: [
        {key: "actionmask", title: "Event Mask"}
      ]
    },
    appRoles: {
      headers: [
        {key: "role", title: "Role"},
        {key: "enabled", title: "Enabled"},
        {key: "title", title: "Title"},
        {key: "caption", title: "Caption"},
        {key: "groups", title: "Groups"},
        {key: "users", title: "Users"}
      ],
      grheaders: [
        {key: "group", title: "Group"},
        {key: "expired", title: "Expires"}
      ],
      uheaders: [
        {key: "user", title: "User"},
        {key: "expired", title: "Expires"}
      ]
    },
    appDatabases: {
      headers: [
        {key: "name", title: "Database"},
        {key: "allow", title: "Allowed by default"},
        {key: "select", title: "Available database fields by default"},
        {key: "filters", title: "Default filters"},
        {key: "roles", title: "Exceptions for specific roles"}
      ],
      rheaders: [
        {key: "role", title: "Role"},
        {key: "allow", title: "What is allowed"},
        {key: "select", title: "Available database fields"},
        {key: "filters", title: "Filters"}
      ]
    },
    emailSMTP: {
      headers: [
        {key: "name", title: "Name (mailbox address)"},
        {key: "enabled", title: "Enabled"},
        {key: "server", title: "Server"},
        {key: "port", title: "Port"},
        {key: "user", title: "User"},
        {key: "pass", title: "Password"},
        {key: "rules", title: "Rules"}
      ],
      rulesHeaders: [
        {key: "useForRecipients", title: "Use for Recipients"},
        {key: "useIfSubject", title: "Use if the topic contains"}
      ]
    },
    emailIMAP: {
      headers: [
        {key: "name", title: "Name (mailbox address)"},
        {key: "autoCheckEnable", title: "Enable auto check"},
        {key: "server", title: "Server"},
        {key: "port", title: "Port"},
        {key: "user", title: "User"},
        {key: "pass", title: "Password"},
        {key: "theOldestMailDate", title: "Check mail until this date (oldest date)"},
        {key: "rules", title: "Rules"}
      ],
      rulesHeaders: [
        {key: "subject", title: "The topic contains"},
        {key: "from", title: "Sender"},
        {key: "body", title: "The letter body contains"},
        {key: "hasAttachments", title: "Has attachments"},
        {key: "serverAction", title: "ServerAction"}
      ]
    }
  },
  chatgpt: {
    history: {
      forgetThisConversation: "Forget this conversation",
      headers: [
        {key: "strDate", title: "Date"},
        {key: "message", title: "Starting a conversation"}
      ]
    }
  },
  fbagroups: {
    title: "Portal user groups",
    headers: [
      {key: "status", title: "Group type"},
      {key: "locked", title: "Locked", hidden: true},
      {key: "enabled", title: "Active/No", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "group", title: "Group"},
      {key: "description", title: "Description"},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]}
    ]
  },
  selectFBAUsersGrid: {
    title: "User selection",
    headers: [
      {key: "login", title: "User login"},
      {key: "name_ru", title: "Name in Russian"},
      {key: "name_en", title: "Name in English"}
    ]
  },
  fbausers: {
    title: "Portal users",
    headers: [
      {key: "status", title: "User type"},
      {key: "locked", title: "Locked", hidden: true},
      {key: "banned", title: "Ban", hidden: true},
      {key: "enabled", title: "Enabled/Disabled", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "thumbnailPhoto", title: "Photo"},
      {key: "name", title: "Username"},
      {key: "name_ru", title: "Name in Russian", hidden: true},
      {key: "name_en", title: "Name in English", hidden: true},
      {key: "login", title: "Login", hidden: true},
      {key: "company", title: "Company"},
      {key: "phones", title: "Phones"},
      {key: "mail", title: "Email"},
      {key: "title", title: "Job title"},
      {key: "description", title: "Description"},
      {key: "activeDevices", title: "Active devices"},
      {key: "groups", title: "Groups", hidden: false},
      {key: "department", title: "Department", hidden: true},
      {key: "office", title: "Office", hidden: true},
      {key: "manager", title: "Manager", hidden: true},
      {key: "country", title: "Coutry", hidden: true},
      {key: "region", title: "Region", hidden: true},
      {key: "city", title: "City", hidden: true},
      {key: "street", title: "Street", hidden: true},
      {key: "viberid", title: "ViberID", hidden: true},
      {key: "viberEnabled", title: "ViberBot enabled", hidden: true},
      {key: "telegramid", title: "TelegramID", hidden: true},
      {key: "telegramEnabled", title: "TelegramBot enabled", hidden: true},
      {key: "mattermostid", title: "MattermostID", hidden: true},
      {key: "mattermostEnabled", title: "MattermostBot enabled", hidden: true},
      {key: "authtypes", title: "Allowed authentication types", hidden: true, visfor: ["admins"]},
      {key: "lng", title: "Interface language", hidden: true, visfor: ["admins"]},
      {key: "theme", title: "Interface theme", hidden: true, visfor: ["admins"]},
      {key: "compact", title: "Compact interface", hidden: true, visfor: ["admins"]},
      {key: "showDesktopIconsTitle", title: "Show desktop icons title", hidden: true, visfor: ["admins"]},
      {key: "awailApps", title: "Available applications", visfor: ["admins"]},
      {key: "desktopApps", title: "Applications on the desktop", hidden: true, visfor: ["admins"]},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]},
      {key: "lastLogon", title: "Last Logon date", hidden: true, visfor: ["admins"]},
      {key: "lastIP", title: "Last IP address", hidden: true, visfor: ["admins"]},
      {key: "pwdLastSet", title: "PWD last set", hidden: true, visfor: ["admins"]},
      {key: "badPasswordTime", title: "Bad password time", hidden: true, visfor: ["admins"]},
      {key: "badPwdCount", title: "Bad password count", hidden: true, visfor: ["admins"]}
    ],
    devsheaders: [
      {key: "type", title: "Type"},
      {key: "devicename", title: "Device"},
      {key: "ip", title: "IP-address"}
    ]
  },
  api1c: {
    c1disabled: "API 1C module is disabled by the Administrator",
    c1LinkIsNull: "Missing the 'API 1C URI' in the program settings",
    c1AuthIsNull: "Missing the 'API 1C Accounting data' in the program settings",
    accessDenied: "Access to the 'API 1C (oData)' is prohibited. Incorrect accounting data",
    userIsntAnAccouter: "The operation is not allowed. You do not belong to a group that has access to 1C",
    doYouWantMarkTheseRecsAsCarriedOutIn1C: "Would you like to mark these records, as the carried out in the 1C Accounting Program?",
    doYouWantMarkTheseRecsAsNotCarriedOutIn1C: "Would you like to unset the mark from the records that they are held the 1C Accounting Program?",
    theseRecsWillBeBlockedInPortal: "The records will be blocked to change and deletion on the Portal",
    theseRecsWillBeUnblockedInPortal: "Records will be unlocked for change and deletion on the portal",
    selectedRecordsWereMarkedAsCarriedOutIn1C: "Selected recordsets were marked as carried out in the 1C Accounting Program",
    selectedRecordsWereUnmarkedAsCarriedOutIn1C: "A mark of the document conduction in the 1C Accounting Program was removed from the selected recordsets"
  }
};
